import { Heading, Text } from '@talkdesk/cobalt-react-typography'
import Box from '@talkdesk/cobalt-react-box'
import Flex from '@talkdesk/cobalt-react-flex'
import Divider from '@talkdesk/cobalt-react-divider'
import {
  USER_SETTINGS_DESCRIPTION,
  USER_SETTINGS_TITLE,
} from '../../constants/ui.labels'
import PasswordSettings from '../../components/PasswordSettings'
import MFASettings from '../../components/MFASettings'
import { withBaseWithMenu } from '../../components/Base'
import { useTheme } from '@talkdesk/cobalt-react-theme-provider'

const HeaderTitle = () => {
  const theme = useTheme()

  return (
    <>
      <Box as='header' padding={['3', '4', '6']}>
        <Heading level='1'>{USER_SETTINGS_TITLE}</Heading>
        <Text color={theme.gray600}>{USER_SETTINGS_DESCRIPTION}</Text>
      </Box>
      <Divider />
    </>
  )
}

const UserSettings = ({
  passwordActions,
  passwordSettings,
  mfaActions,
  mfaSettings,
  isLocalLoginEnabled,
  siteKey,
}) => (
  <Flex direction='column' width='100%'>
    <Box width='100%'>
      <PasswordSettings
        {...passwordActions}
        {...passwordSettings}
        isLocalLoginEnabled={isLocalLoginEnabled}
      />
    </Box>
    <Divider />
    <Box width='100%'>
      <MFASettings
        {...mfaActions}
        {...mfaSettings}
        isLocalLoginEnabled={isLocalLoginEnabled}
        siteKey={siteKey}
      />
    </Box>
  </Flex>
)

export default withBaseWithMenu(UserSettings, HeaderTitle)
